export const SelectedSkinDataActionType = {
	SET_SELECTED_SKIN_DATA: "SET_SELECTED_SKIN_DATA",
};
